import { useMemo } from "react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import useGlobalContext from "../../../../../../hooks/useGlobalContext.js";
import { getLeastAvailableLuggagePerTrip } from "../../../../../../store/selectors/searchResultsAvailableLuggage.js";
import useGetSearchResultsBound from "../../../../../../hooks/useGetSearchResultsBound.js";
export const useFlightCardLuggageController = (flight, isWithFlexTicket) => {
    const { segments, ancillaries } = flight;
    const { supportsChildrenTickets } = useGlobalContext();
    const i18n = useI18n();
    const bound = useGetSearchResultsBound();
    const { personalItem: personalItemIncluded, cabinLuggage: cabinIncluded, checkedInLuggage: checkedIncluded } = getLeastAvailableLuggagePerTrip(bound === "outbound" ? [segments[0]] : segments, supportsChildrenTickets);
    const luggageList = useMemo(() => {
        const result = [];
        if (personalItemIncluded) {
            result.push({
                ancillaryType: "PERSONAL_ITEM",
                inclusionType: "INCLUDED",
                text: i18n.trans(t("flights_sr_hover_personal_item")),
                ariaLabel: i18n.trans(t("a11y_flights_mdot_sr_personal_included"))
            });
        }
        if (cabinIncluded) {
            result.push({
                ancillaryType: "CABIN",
                inclusionType: "INCLUDED",
                text: i18n.trans(t("flights_sr_hover_cabin_bag")),
                ariaLabel: i18n.trans(t("a11y_flights_mdot_sr_cabin_included"))
            });
        }
        if (checkedIncluded) {
            result.push({
                ancillaryType: "CHECKED",
                inclusionType: "INCLUDED",
                text: i18n.trans(t("flights_sr_hover_checked_bag")),
                ariaLabel: i18n.trans(t("a11y_flights_mdot_sr_checked_included"))
            });
        }
        if (isWithFlexTicket && ancillaries?.flexibleTicket) {
            result.push({
                ancillaryType: "FLEX_TICKET",
                inclusionType: "EXTRA",
                text: i18n.trans(t("flights_sr_hover_flex_ticket")),
                ariaLabel: i18n.trans(t("flights_sr_hover_flex_ticket"))
            });
        }
        return result;
    }, [ancillaries?.flexibleTicket, cabinIncluded, checkedIncluded, i18n, isWithFlexTicket, personalItemIncluded]);
    return {
        luggageList
    };
};
